const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>
            Hi! I'm <b><k>Areeb Jamal!</k></b>
          </p>
          <p>
            Welcome to my small <b><k>space</k></b> of the internet, where I am taking refuge from the evil viruses taking over the world wide web!
          </p>
          <p>
            That's right, the internet is currently being attacked by evil hackers and I need <b><k>your help!</k></b> First, get to know me by navigating through this website!
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "B.Eng. Computer + Management",
      content: (
        <>
          <p>
            <b>McMaster University: Sept. 2020 - Apr. 2025</b>
          </p>
          <p>
            Currently, I am in my fourth-year with a <b>3.8 GPA</b> and recognized by the world's largest honour society, 
            the Golden Key International Honour Society for being in the <b>top 15%</b> of my program. 
            The Computer Engineering & Management Program at McMaster is a prestigious 5-year program designed to provide 
            engineering students with a deeper understanding of the business, project management, 
            and leadership skills needed to thrive in a corporate, entrepreneurial and <b><k>evil virus war </k></b>environment. 
          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "Wireless Network Operations Intern",
      content: (
        <>
          <p>
            <b>Bell Canada: May 2023 - Aug. 2023</b>
          </p>
          <p>
            <b>-</b> Administered and launched <b>9</b> capital projects across the GTHA alongside <b>800+</b> preexisting cell sites contributing to
            efficiently delivering quality fiber and cellular network coverage to <b>99%</b> of Canadians.<br />
            <b>-</b> Streamlined troubleshooting processes through creative innovations alongside advising a team of <b>34</b> technicians on
            prioritization strategies which efficiently saved company time by <b>11%</b>.<br />
          </p>
        </>
      ),
    },
    {
      title: "RF Network Engineer Intern",
      content: (
        <>
          <p>
            <b>Ericsson Canada: May 2022 - Aug. 2022</b>
          </p>
          <p>
            <b>-</b> Monitored a variety of radio frequency signals and bands for <b>300+</b> sites across the city of Jacksonville remotely and
            generated detailed site summaries for customers.<br/>
            <b>-</b> Analyzed high VSWR through KPIs to further optimize radio network performance which boosted the efficiency of available
            network resources by <b>24%</b>.<br />
          </p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
